
import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useState } from "react";
import "../Styles/AdminListings.css";
import { getUserAuditRecords } from '../../common/constants/globalconstants';
import { auditReportColumns, auditReportExcelColumns} from "./auditReportColumns";
import { Backdrop, Box, Button, CircularProgress, FormControl, TextField, Stack, InputAdornment, IconButton, MenuItem, Select, Grid} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import { Search } from "@mui/icons-material";
import ErrorModal from "../../common/ErrorModal";
import { CustomExcelExport } from "../../common/CustomExcelExport";
import axiosInstance from "../../common/AxiosInterceptor";
//#F2F3F5 alternate color

const customStyle = {
	table: {
	  style: {
		border: "1px solid #DEDEDE",
		borderRadius: "5px",
		justifyContent: "center",
		marginBottom: "10px",
		marginTop: "10px",
	  },
	},
	header: {
	  style: {
		color: "#193062",
	  },
	},
	headRow: {
	  style: {
		border: "none",
		backgroundColor: "#CDD4DC",
		fontWeight: "bold",
		color: "#002d82",
		fontSize: "14px",
		whiteSpace: "unset",
	  },
	},
	rows: {
	  stripedStyle: {
		backgroundColor: "#F2F3F5",
		justifyContent: "center",
	  },
	},
  };

function AuditReport() {
    const [records, setRecords] = useState([]);
	const [originalData, setOriginalData] = useState([]);
	const [errormodalopen, seterrormodalOpen]= useState(false);
	const [loading, setloading] = useState(false);
	const [loginFrom, setLoginFrom] = useState("all");
	const [initialData, setInitialData] = useState([]);
	const [logDate, setLogDate] = useState(dayjs(new Date()));
	const [customDateErr, setCustomDateErr] = useState("");
	const [customDefaultDate, setCustomDefaultDate] = useState(null);
	const [searchField, setSearchField] = useState("");
	const [searching, setSearching] = useState(false);
	const [showCustomDate, setShowCustomDate] = useState(false);
	const [resetPagination, setRstPagination] = useState(false);
	const [tableKey, setTableKey] = useState(0);
	const [resetSort, setResetSort] = useState(true);

	useEffect( () => {
		fetchUserLoggedInRecords("initial");				
	}, [])

	const constructUrl =(base, date)=>{
		const params = new URLSearchParams();
		params.append("date", date || '');
		return `${base}?${params.toString()}`;
	}

	const fetchUserLoggedInRecords = async(type) => {
		let url;
		try{
		setloading(true);
		if(type==="initial" || (type==="search" && loginFrom==="all")){
			const date='';
			url=constructUrl(`${getUserAuditRecords}`,date)
		}
		else if(type==="search" && loginFrom!=="custom" && loginFrom!=="all"){
			url=constructUrl(`${getUserAuditRecords}`,logDate)
		}
		else if(type==="search" && loginFrom==="custom" && loginFrom!=="all"){
			url=constructUrl(`${getUserAuditRecords}`,customDefaultDate)
		}
		else{
			url=constructUrl(`${getUserAuditRecords}`,"")
		}
		const response = await axiosInstance.get(url);
		if (response.data.isSuccess) {
			setRecords(response.data.result);
			setOriginalData(response.data.result);
			setInitialData(response.data.result);
			setTableKey(prevKey=>prevKey+1);
			seterrormodalOpen(false);
		  } else if (!response.data.isSuccess) {
			seterrormodalOpen(true);
		  }
		  setloading(false);
		} catch (error) {
			console.log(error);
			seterrormodalOpen(true);
			setloading(false);
		  }
	}

	const subtractMonthsAndDay = (date, months)=>{	
		const defaultDate= dayjs(date)
		.subtract(months, 'month');
		setCustomDefaultDate(defaultDate);
		const d = dayjs(date)
		.subtract(months, 'month');
		//.subtract(1, 'day');
		return d.format('MM-DD-YYYY');
	}

	const handleChange =(e) =>{
		setLoginFrom(e.target.value);
		if(e.target.value==="all"){
			setShowCustomDate(false);
			setCustomDefaultDate("");
		}
		if(e.target.value === "last12months"){
			const months = parseInt("12",10);
			const newDate = subtractMonthsAndDay(new Date(), months);
			setLogDate(newDate);
			setShowCustomDate(false);
		}
		if(e.target.value === "last18months"){
			const months = parseInt("18",10);
			const newDate = subtractMonthsAndDay(new Date(), months);
			setLogDate(newDate);
			setShowCustomDate(false);
		}
		if(e.target.value==="custom"){
			setShowCustomDate(true);
			setCustomDefaultDate("");
		}
		else{
			setShowCustomDate(false);
			//setCustomDefaultDate("");
		}
	}

	const validateCustomDate =()=>{
		let error = false;
		if(loginFrom === "custom" && (customDefaultDate == "" || customDefaultDate == null)){
			setCustomDateErr("Please select Custom Date");
			error = true;
		}else{
			setCustomDateErr("");
		}
		return error;
	}
	
	const handleSearchClick =()=>{
		let error = validateCustomDate();
		if(!error){
			setRstPagination(!resetPagination);
			setSearchField("");
			setSearching(false);
			fetchUserLoggedInRecords("search");
		}		
	}

	const handleResetClick =()=>{		
		setRstPagination(!resetPagination);
		fetchUserLoggedInRecords("initial");
		setLoginFrom("all");
		setCustomDefaultDate("");
		setSearchField("");
		setShowCustomDate(false);
		setSearchField("");
		setCustomDateErr("");
		setResetSort(!resetSort);
		setInitialData(originalData);
		setTableKey(prevKey=>prevKey+1);
	}

  	
	  const dateHandler = (e) => {
		var date = new Date(e.$d);
		const dayjsDate = dayjs(date);
		//const modifiedDate = dayjsDate.subtract(1, 'day');
		//const finalDateMinus1 = modifiedDate.format('MM-DD-YYYY');
	    const customSelected = dayjsDate.format('MM-DD-YYYY');
		//setCustomDate(finalDateMinus1);
		setCustomDefaultDate(customSelected);		
	  };

	  const handleChangeSearchText = (e) =>{
		setRstPagination(!resetPagination);
		setSearching(true);
		setSearchField(e.target.value);
		let searchValue =false;
		let userName = false ;
		let companyName = false;
			let browserName = false ;
			let browserVersion = false;
			let remoteAddress = false ;
			let userType = false;
			let logDate = false;
			const newdata = records && records.filter( row => {
				userName = row.userName && row.userName.toLowerCase().includes(e.target.value.toString().toLowerCase());
				companyName = row.careFacilityName && row.careFacilityName.toLowerCase().includes(e.target.value.toString().toLowerCase());
				browserName = row.browserName && row.browserName.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
				browserVersion = row.browserVersion && row.browserVersion.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
				userType = row.userType && row.userType.toString().toLowerCase().includes(e.target.value.toString().toLowerCase());
				remoteAddress = row.remoteAddress && row.remoteAddress.toString().includes(e.target.value.toString());
				logDate = row.logDate && row.logDate.toString().includes(e.target.value.toString());
				if(userName){
					searchValue = userName
				}
				else if(companyName){
					searchValue = companyName
				}
				else if(browserName){
					searchValue = browserName
				}
		  		else if(browserVersion){
					searchValue = browserVersion
				}
				else if(remoteAddress){
					searchValue = remoteAddress
				}
				else if(logDate){
					searchValue = logDate
				}
		  		else{
					searchValue = userType
				}
				return searchValue;
			})
				setInitialData(newdata);
	  }

    return (
		<div>
		<Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
		  //margin:"18px",
          left: "2%",
          flexDirection: "column",
          width: "97%",
          //marginTop: "20px",
          //marginBottom: "20px",
          alignItems: "center",
          //p: "0% 2%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
            <h2 className="header">User Login Audit</h2>
            
			<Box
			sx={{
				justifyContent:"center",
				alignContent:"center",
				alignItems:"center",
				display:"flex",
				width:"100%",
				height:"15px"
			}}>
			<p style={{color:"red", marginTop:"4px"}}>{customDateErr ? customDateErr : ""}</p>
			</Box>
			
			{loading && (
                  <>
                <Backdrop
                  sx={{
                    color: "white",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                  }}
                  open={true}
                >
                  <CircularProgress sx={{ color: "white" }} />
                  <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading... </span>
                </Backdrop>
                </>
                )}
			<Grid container style={{width:"100%"}}>
			<div style={{ width: "99%",  marginTop:"5px"}}>
			<Box
			sx={{
				flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
				//paddingLeft:"5px",
				paddingRight:"5px"
			}}>
			<Stack
            direction="row"
            alignItems="left"
            columnGap="1.5rem"
            justifyContent="left"
            sx={{ width: "100%", height: "70px", m: "3px 0",  marginLeft:"5px" }}
            >
			<Box sx={{
				width:"100%", 
				gap:"1.5rem", 
				display:"flex", 
				flexDirection:"row", 
				border: "1px solid #002d82", 
				borderRadius: "5px",
				boxShadow: "none"
				}}>
			<Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
				height: "60px",
				width:"32%"
              }}
            >
			<>
			 <p style={{width: "200px", marginTop: "10px",color: "black",fontWeight: "600",marginLeft: "12px"}}>Not Logged In:</p>
			 
			 <FormControl variant="outlined" fullWidth margin="normal" size='small' sx={{width:"260px"}} style={{width:"260px"}}>
                        {/* <InputLabel>Not Logged In Since</InputLabel> */}
                            <Select							 
                            name="loginFrom"
                            value={loginFrom}
                            onChange={handleChange}
                            >
                            <MenuItem value="all">
							<em>----------- Select -----------</em>
							</MenuItem>   
                            <MenuItem value="last12months">Last 12 Months</MenuItem>
                            <MenuItem value="last18months">Last 18 Months</MenuItem>
                            <MenuItem value="custom">Custom</MenuItem> 
                            </Select>                    
                    </FormControl>
			
			</> 			
			</Box>
			<Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
				width:"32%",
              }}
            >
				{//showCustomDate ? 
				<>
			 <p style={{width: "180px", color: "black",fontWeight: "600",marginLeft: "5px"}}>
				Custom Date:</p>
						<DatePicker
						className="report-to-datePicker"
						disabled={!showCustomDate}
						sx={{ ml: "0px", width: "260px", marginBottom:"28px", marginRight:"20px", "& .MuiInputBase-input":{ height: "7px !important"} }}
						inputFormat="MM DD YYYY"
						onChange={dateHandler}
						value={dayjs(customDefaultDate)}
						disableFuture={true}
						size="small"
						maxDate={dayjs(new Date().setDate(new Date().getDate()-1))}
						slotProps={{
							textField:{
								error:false
							}
						  }}
						>
						</DatePicker>
						</>
						//: null
						}
			</Box>
			<Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
				columnGap:"1rem",
              }}
            >
				<Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "120px", marginLeft: "3px", marginBottom: "5px"}}
					onClick={handleSearchClick}
				  >
					Search
				  </Button>
  
				   <Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "120px", marginBottom: "5px", marginLeft: "1px"}}
					onClick={handleResetClick}
				  >
					Reset
				  </Button> 
				  {/* {initialData && initialData.length>0? 
				<CustomExcelExport
					filename={`UserAuditReport.xlsx`}
					data={initialData}
					headers={auditReportExcelColumns}
					//type={"align-left"}
					reportType={"audit_report"}
					>
				</CustomExcelExport>
				: null} */}
			</Box>
			</Box>
			{/* <Box
              display="flex"
              sx={{
                flexDirection: "row",
                alignItems: "center",
                //justifyContent: "space-between",
				//width: "20%"
				justifyContent: "right", 
				textAlign:"right", 
				float:"right"
              }}
            >
				{(initialData && initialData.length>0) || searching?
                    <TextField 
					type="text" variant="outlined"
                    sx={{
						borderRadius:'5px', 
						height:"10px !important", 
						marginBottom:"35px !important", 
						width:"200px"}} 
                    placeholder="Search"
					value={searchField}
                    onChange={(e)=>handleChangeSearchText(e)}
                    className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'5px', paddingLeft: '5px', height: "40px", textAlign:"center"}
                        }} 
                    />
					: null}
			</Box> */}
			</Stack>

		  </Box>
		  	</div>
		  </Grid>
		 
		  <Box sx={{display:"flex", flexDirection:"row", width:"100%", height:"55px", alignItems:"center"}}>
			<Box sx={{width:"50%", alignContent:"left", float:"left", justifyContent:"left",textAlign:"left"}}>
				<div style={{alignContent:"left", marginTop:"10px"}}>
				{initialData && initialData.length>0? 
				<CustomExcelExport
					filename={`UserAuditReport.xlsx`}
					data={initialData}
					headers={auditReportExcelColumns}
					type={"align-left"}
					>
				</CustomExcelExport>
				:null}
				</div>
				</Box>
			<Box sx={{width:"50%", alignContent:"right", float:"right", justifyContent:"right"}}>
				<div style={{alignContent:"right", textAlign:"right"}}>
			{(initialData && initialData.length>0) || searching?
                    <TextField 
					type="text" variant="outlined"
                    sx={{borderRadius:'5px', height:"10px !important", marginBottom:"25px !important"}} 
                    placeholder="Search"
					value={searchField}
                        onChange={(e)=>handleChangeSearchText(e)}
                        className='search-report-text'
                        InputProps={ {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton>
                                        <Search />
                                    </IconButton>
                                </InputAdornment>
                            ),
                            sx:{ borderRadius:'5px', paddingLeft: '5px', height: "40px", textAlign:"center"}
                        }} 
                    />
					: null}
				</div>
			</Box>		 
         </Box>
		
			
			<DataTable
				title=""
				key={tableKey}
				columns={auditReportColumns}
				data={initialData}
				pagination
				striped
				highlightOnHover
				customStyles={customStyle}
				defaultSortFieldId={null}
				defaultSortAsc={null}
				paginationRowsPerPageOptions={[5,10,15,20]}
				paginationResetDefaultPage={resetPagination}
				paginationPerPage={5}
				paginationComponentOptions={{
					rowsPerPageText:'Records per page',
					rangeSeparatorText:'Out of'
				}}
			/>
		</Box>
		{errormodalopen && (
            <ErrorModal open={errormodalopen} onClose={() => seterrormodalOpen(false)} />
             )}
		</div>
    ) ;
}

export default AuditReport;
